import { CustomizableValidator } from '../../types/Validator';

const errorCode = 'MIN_NUMBER';

interface MatchProps {
  min: number;
}

const minNumber: CustomizableValidator<MatchProps> = ({
  min,
  variables
}) => value => {
  if (min && Number(value) < min) {
    return {
      errorCode,
      params: variables
    };
  }
};

export { minNumber, errorCode };
